var _path, _rect, _rect2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeTeamActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52 21H21V52H38.687L52 38.0023V21Z",
    fill: "#1565D8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 31,
    transform: "matrix(-1 0 0 1 21 21)",
    fill: "#1565D8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 21,
    width: 52,
    height: 21,
    transform: "rotate(-180 52 21)",
    fill: "#1565D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.9999 29.4001L21.2399 31.6701L22.2399 27.3901L18.9199 24.5101L23.2999 24.1301L24.9999 20.1001L26.7099 24.1401L31.0899 24.5201L27.7699 27.4001L28.7699 31.6801L24.9999 29.4001Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 23.24L27.81 22.62L25 16L22.19 22.63L15 23.24L20.46 27.97L18.82 35L25 31.27L31.18 35L29.55 27.97L35 23.24ZM25 29.4L21.24 31.67L22.24 27.39L18.92 24.51L23.3 24.13L25 20.1L26.71 24.14L31.09 24.52L27.77 27.4L28.77 31.68L25 29.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeTeamActive);
export default __webpack_public_path__ + "static/media/pe-team-active.77371adcf74eabbc1c0bb3bcef2c5400.svg";
export { ForwardRef as ReactComponent };